import React from "react";
import { PaginatedUsersAPI } from "../../../../../../../../libs/Utils/Types/APIManagement";
import { TableColumnsType } from "antd";
import Elipses from "../../../../../../../../global components/Icons/Elipses";
import ReusableTable from "../../../../../../../../global components/Table/Table";
import dayjs from "dayjs";
import ReusablePopover from "../../../../../../../../global components/Popover/ReuseablePopover";
import ActionPopOverDetails from "../ActionPopOverDetails";

type ColumnType = {
  key: string;
  user: string; // ISO date string
  totalApiKeyCount: number;
  totalRequests: number;
  lastActivity: string;
};
type PropType = {
  data: PaginatedUsersAPI["data"];
  loading: boolean;
  mutate: () => void;
};
function UsersTable({ data, loading, mutate }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (user: string) => <span>{user}</span>,
    },
    {
      title: "API Created Count",
      dataIndex: "totalApiKeyCount",
      key: "totalApiKeyCount",
      render: (totalApiKeyCount: string) => <span>{totalApiKeyCount}</span>,
    },
    {
      title: "Requests",
      dataIndex: "totalRequests",
      key: "totalRequests",
      render: (totalRequests: string) => <span>{totalRequests}</span>,
    },
    {
      title: "Last Activity",
      dataIndex: "lastActivity",
      key: "lastActivity",
      render: (lastActivity: string) => <span>{lastActivity}</span>,
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (actions: string, record: { key: string; user: string }) => (
        <ReusablePopover
          trigger={"hover"}
          content={<ActionPopOverDetails id={record.key} name={record.user} />}
        >
          <Elipses width={24} cursor={"pointer"} height={24} />
        </ReusablePopover>
      ),
    },
  ];
  const dataSource: ColumnType[] = data.map((item) => ({
    lastActivity: dayjs.utc(item.lastActivity)
      .local()
      .format("YYYY-MM-DD hh:mm:ss"),
    totalApiKeyCount: item.totalApiKeyCount,
    key: item.userId,
    totalRequests: item.totalRequests,
    user: item.firstName + " " + item.lastName,
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={loading}
    />
  );
}

export default UsersTable;
